module.exports = __webpack_public_path__ + "img/4.abd5863.webp";